import React, { useState } from 'react';
import { Tabs } from 'antd';
import { DashboardOutlined, TableOutlined } from '@ant-design/icons';
import ControlServiciosTable from './ControlServiciosTable';
import ControlServiciosDashboard from './ControlServiciosDashboard';

const { TabPane } = Tabs;

const ControlServiciosIndex = () => {
  const [activeTab, setActiveTab] = useState('dashboard');

  return (
    <div style={{ padding: '20px' }}>
      <Tabs activeKey={activeTab} onChange={setActiveTab} size="large">
        <TabPane
          tab={
            <span>
              <DashboardOutlined />
              Dashboard
            </span>
          }
          key="dashboard"
        >
          <ControlServiciosDashboard />
        </TabPane>
        <TabPane
          tab={
            <span>
              <TableOutlined />
              Listado de Controles
            </span>
          }
          key="tabla"
        >
          <ControlServiciosTable />
        </TabPane>
      </Tabs>
    </div>
  );
};

export default ControlServiciosIndex;
